import env from './dev'

env.env = 'prod'
env.BASEURL = '//xyapi.jingzhuan.cn'
// env.apiUrlPrefix = '//xyapi.jingzhuan.cn/api'
env.apiUrlPrefix = '//college.jingzhuan.cn/api'
env.loginPage = '//loginxy.jingzhuan.cn'
env.exam = '//examapi.jingzhuan.cn/api'

export default env
